import {Component, inject, Input, output} from '@angular/core';
import {SelectRegistrantTypeService} from "../../register/components/select-registrant-type-modal/select-registrant-type.service";
import {Router} from "@angular/router";
import {RegistrantType} from "../../../../../generated-model/model";

@Component({
  selector: 'app-register-panel',
  standalone: true,
  imports: [],
  templateUrl: './register-panel.component.html',
  styleUrl: './register-panel.component.scss'
})
export class RegisterPanelComponent {
  @Input() redirectUrl: string[] = [];
  onSelectRegistrantType = output<RegistrantType>()
  registerModalService = inject(SelectRegistrantTypeService);
  router = inject(Router);

  register() {
    // this.registerModalService.open()
    //   .subscribe(registrantType => {
    //     if (registrantType) {
    //       this.onSelectRegistrantType.emit(registrantType);
    //     }
    //   });
    this.onSelectRegistrantType.emit('SELF');
  }
}
